<template>
  <common-dialog @opened="onOpened" ref="dialog" :title="title" :modal="true" width="1300px" :in-dialog="inDialog">
    <list
      row-key="AnalyseStudentId"
      ref="list"
      unit="学生信息"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.getAnalyseStudents"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="班级">
          <el-select v-model="params.ClassId" size="mini" style="width:100%;">
            <el-option v-for="item in classList" :key="item.ClassId" :value="item.ClassId" :label="item.ClassName"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="姓名">
          <el-input v-model="params.FullName" size="mini" placeholder="请填写姓名"></el-input>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SubjectGroup" label="组合" />
        <el-table-column prop="FullName" label="姓名">
          <template slot-scope="{row}">
            <el-link @click="toDetails(row)">{{row.FullName}}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="StudentNumber" label="学生编号" />
        <el-table-column prop="Change" label="本次变动">
          <template slot-scope="{row}">
            <span v-if="row.Change==0">无</span>
            <span v-else-if="row.Change==1">平</span>
            <span v-else-if="row.Change==2">进</span>
            <span v-else-if="row.Change==3">退</span>
          </template>
        </el-table-column>
        <el-table-column prop="ChangeTrend" label="变动趋势">
          <template slot-scope="{row}">
            <span v-if="row.ChangeTrend==0">无</span>
            <span v-else-if="row.ChangeTrend==1">平</span>
            <span v-else-if="row.ChangeTrend==2">进</span>
            <span v-else-if="row.ChangeTrend==3">退</span>
          </template>
        </el-table-column>
        <el-table-column prop="NewTotalScore" label="新总分">
          <template slot-scope="{row}">
            <span v-if="row.NewTotalScore==-1">缺考</span>
            <span v-else>{{row.NewTotalScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="NewTotalSn" label="新总分序">
          <template slot-scope="{row}">
            <span v-if="row.NewTotalSn==-1">缺考</span>
            <span v-else>{{row.NewTotalSn}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="EntryNewTotalScore" label="入口新总分" min-width="85">
          <template slot-scope="{row}">
            <span v-if="row.EntryNewTotalScore==-1">缺考次数超过一半</span>
            <span v-else>{{row.EntryNewTotalScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="EntryNewTotalSn" label="入口新总分序" min-width="95">
          <template slot-scope="{row}">
            <span v-if="row.EntryNewTotalSn==-1">缺考</span>
            <span v-else>{{row.EntryNewTotalSn}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="FourScore" label="四科">
          <template slot-scope="{row}">
            <span v-if="row.FourScore==-1">缺考</span>
            <span v-else-if="row.FourScore==-2"></span>
            <span v-else>{{row.FourScore}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="FourSn" label="四科序">
          <template slot-scope="{row}">
            <span v-if="row.FourSn==-1">缺考</span>
            <span v-else-if="row.FourScore==-2"></span>
            <span v-else>{{row.FourSn}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="StrongSubjects" label="强势科" />
        <el-table-column prop="StrongTeacherNames" label="强势科任" />
        <el-table-column prop="WeakSubjects" label="弱势科" />
        <el-table-column prop="WeakTeacherNames" label="弱势科任" />
        <el-table-column prop="TeacherNames" label="跟踪教师" />
        <el-table-column prop="Star" label="星级" align="center" width="90">
          <template slot-scope="{row}">
            <span v-if="row.Star==1"><i class="el-icon-star-on" /></span>
            <span v-else-if="row.Star==2"><i class="el-icon-star-on" /><i class="el-icon-star-on" /></span>
            <span v-else-if="row.Star==3"><i class="el-icon-star-on" /><i class="el-icon-star-on" /><i class="el-icon-star-on" /></span>
            <el-button type="text" class="el-icon-edit" @click="setStar(row)" v-else></el-button>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" size="small" @click="close">关 闭</el-button>
      </slot>
    </template>
    <star-dialog ref="starDialog" @confirm="confirm" in-dialog></star-dialog>
    <details-dialog ref="detailsDialog" in-dialog></details-dialog>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "@/components/common/list";
import listMixin from "@/mixins/list";
import listDialogMixins from "@/mixins/listDialog";
import starDialog from "./starDialog";
import detailsDialog from "./detailsDialog";

export default {
  components: { 
    commonDialog,
    list,
    starDialog,
    detailsDialog
  },
  mixins: [listDialogMixins,listMixin],
  props: {
    title: {
      type: String,
      default: "学生信息"
    },
  },
  data() {
    return {
      api: require("@/api/analyse/analyse").default,
      examApi: require("@/api/achieve/exam").default,
      classApi: require("@/api/ed/class").default,
      params: {
        // ClassId: null,
        FullName: "",
      },
      type: null,
      classList: [],
    }
  },
  methods:{
    onOpened(data){
      this.type = data.type;
      // this.examApi.list({ ExamId: data.ExamId }).then(res => {
      //   if(res.Code == 0) {
      //     let gradeList = [];
      //     res.Data.forEach((e,index) => {
      //       if(gradeList.indexOf(e.GradeId) == -1) {
      //         gradeList.push(e.GradeId);
      //       }
      //       if(index == res.Data.length-1) {
      //         this.classList = [];
      //         gradeList.forEach(e => {
      //           this.classApi.list({ GradeId: e, TermId: data.TermId }).then(cres => {
      //             if(cres.Code == 0) {
      //               this.classList = this.classList.concat(cres.Data);
      //             }
      //           })
      //         })
      //       }
      //     })
      //   }
      // })
    },
    toDetails(row) {
      this.$refs.detailsDialog.open({ ...row, type: this.type });
    },
    setStar(row) {
      this.$refs.starDialog.open();
      this.$refs.starDialog.setData({  type: this.type, ...row });
    },
    confirm(data) {
      // console.log('data',data)
      this.query();
    }
  }
};
</script>
<style>
.el-icon-star-on{
  color: #f7ba2a;
  font-size: 16px;
}
</style>